module.exports = __webpack_public_path__ + "img/banner-4-black.b7e7dca3.jpg";